
import { defineComponent, PropType, computed } from "vue";
export default defineComponent({
  name: "CheckboxInput",
  props: {
    input: { type: Object as PropType<any>, required: true },
    modelValue: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    return { model };
  },
});
